import { Box } from "@mui/material";
import { usePartyLicensesQuery } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { LicenseDetailWithPaymentActions } from "Components/Licenses/LicensesPageContent/LicenseDetailWithPaymentActions";
import { LicensesPageContentSkeleton } from "Components/Licenses/LicensesPageContent/LicensesPageContentSkeleton";
import { OrderNewLicenseButton } from "Components/Licenses/LicensesPageContent/OrderNewLicenseButton";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useIsMobile } from "Hooks/useIsMobile";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Resources, useResource } from "Translations/Resources";

export const LicensesPageContent = () => {
  const isMobile = useIsMobile();
  const { t } = useResource();
  const currentUser = useLoggedInUser();
  const {
    data: { items: licenses = [] } = {},
    isLoading,
    isError,
  } = usePartyLicensesQuery(currentUser?.partyPublicID);

  if (isLoading) {
    return <LicensesPageContentSkeleton />;
  }

  if (isError) {
    return (
      <PrimaryPaper>
        <ErrorText>
          {t(Resources.Pages.Content.LicenseDetail.LoadingError)}
        </ErrorText>
      </PrimaryPaper>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={isMobile ? 2 : 1}>
      {licenses.map((license) => (
        <LicenseDetailWithPaymentActions
          key={license.publicID}
          license={license}
        />
      ))}
      <Box mt={3}>
        <OrderNewLicenseButton />
      </Box>
    </Box>
  );
};
